import React, { useState, useContext } from "react";
import { MainContext } from "../../contexts/MainContext";
import useLanguage from "../../hooks/useLanguageHook";
import useHttpHook from "../../hooks/useHttpHook";

const B3SettingsComponent = () => {
    const { userData } = useContext(MainContext);
    const { languageData } = useLanguage();
    const { httpRequest } = useHttpHook(); // ✅ Use the custom hook
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");

    const handleFileChange = (event) => {
        setFiles(event.target.files);
    };

    const handleUpload = async () => {
        if (files.length === 0) {
            setMessage(languageData.b3Section.noFilesWarning);
            return;
        }

        const formData = new FormData();
        for (const file of files) {
            formData.append("files", file);
        }

        try {
            setUploading(true);
            setMessage(languageData.b3Section.uploading.replace("{progress}", "0"));

            const response = await httpRequest(
                "POST",
                `/b3/users/${userData?.userId}/sheets`,
                formData,
                true // ✅ Marks it as a file upload
            );

            setMessage(languageData.b3Section.uploadSuccess.replace("{totalInserted}", response.totalInserted));
        } catch (error) {
            console.error("Upload error:", error);
            setMessage(languageData.b3Section.uploadError);
        } finally {
            setUploading(false);
            setProgress(0);
        }
    };

    return (
        <div className="container">
            <div className="box">
                <h3 className="subtitle">{languageData.b3Section.uploadTitle}</h3>
                <input type="file" multiple accept=".xlsx" onChange={handleFileChange} className="input"/>
                <button className="button is-primary mt-3" onClick={handleUpload} disabled={uploading}>
                    {uploading ? languageData.b3Section.uploading.replace("{progress}", progress) : languageData.b3Section.uploadButton}
                </button>
                <p className="mt-2">{message}</p>
            </div>
        </div>
    );
};

export default B3SettingsComponent;
